import utilsStyles from '@/styles/modules/utils.module.scss';
import styles from './ECommerceSearchNotFound.module.scss';

function ECommerceSearchNotFound() {
  return (
    <div className={styles.componentStyle}>
      <p className={`${utilsStyles.textLarge} ${utilsStyles.textBold}`}>検索結果が見つかりませんでした。</p>
      <p className={styles.description}>
        入力した内容に誤りがないか確認するか、
        <br />
        別の検索ワードを入力して再度検索してください。
      </p>
    </div>
  );
}

export default ECommerceSearchNotFound;
